import { DialogActions } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { FoldersApi } from "../../../api/folders/folders";
import { useSnackbar } from "../../../data/SnackbarContext";
import { DELETE_FOLDER_DIALOG, SNACKBAR_MESSAGES } from "../../../data/StringConstants";
import CustomButton from "../../CustomButton/CustomButton";

import analytics from "../../../utils/analytics";

/**
 * @description Delete Folder by ID, DialogAction content. Please inside a CustomConfirmationDialog wrapper
 * @param {number} id ID of folder to be deleted
 * @param {function} toggle Supplied to the `cancel` button
 * @param {function} callback Function to execute at the end of the api call
 * @todo - the callback here would be useful to implement audit trails for FE metrics
 */
export default function DeleteFolderDialogActions({ folderId, folderName, toggle, callback }) {
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar();

  const _deleteFolder = async folderId => {
    try {
      analytics.logEvent(analytics.eventTypes.FOLDERS.DELETE_FOLDER_CONFIRMATION_CLICKED, {
        folder: {
          id: folderId,
          name: folderName
        },
        cancelOrDelete: "delete"
        });

      const result = await FoldersApi.deleteFolder(folderId);

      if (result.status === 200) {
        showSuccessSnackbar(SNACKBAR_MESSAGES.DELETE_FOLDER_SUCCESS);
        callback(result);
      }
    } catch (error) {
      showErrorSnackbar(SNACKBAR_MESSAGES.DELETE_FOLDER_ERROR);
    }
  };

  const cancel = () =>
  {
    analytics.logEvent(analytics.eventTypes.FOLDERS.DELETE_FOLDER_CONFIRMATION_CLICKED, {
      folder: {
        id: folderId,
        name: folderName
      },
      cancelOrDelete: "cancel"
    });
    toggle();
  };

  return <DialogActions>
    <CustomButton onClick={cancel}>
      {DELETE_FOLDER_DIALOG.CANCEL_BTN}
    </CustomButton>
    <CustomButton
      color="error"
      variant="contained"
      onClick={() => _deleteFolder(folderId)}
    >
      {DELETE_FOLDER_DIALOG.DELETE_BTN}
    </CustomButton>
  </DialogActions>
}

DeleteFolderDialogActions.propTypes = {
  folderId: PropTypes.number.isRequired,
  toggle: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
}